import React from 'react';
import { useLogo } from '../hooks/useLogo';

const LogoImage = () => {
	const { width, height, title, color, url, showLabel } = useLogo(); // hook
	const { blockClass } = useLogo();

	const renderLabel = () => {
		if (showLabel) {
			return title;
		}
		return '';
	};

	const renderStyles = () => {
		const styles = {
			width: isNaN(Number(width)) || !width ? undefined : width,
			height: isNaN(Number(height)) || !height ? undefined : height,
			color: color,
		};
		//delete undefined
		Object.keys(styles).forEach((key) => styles[key] === undefined && delete styles[key]);
		return styles;
	};

	return (
		<img
			style={renderStyles()}
			alt={renderLabel()}
			className={`logoImage logoImage--${blockClass} vtex-store-components-3-x-logoImage ${blockClass ? 'vtex-store-components-3-x-logoImage--' + blockClass : ''} vtex-render-runtime-8-x-lazyload `}
			data-src={url}
			loading="lazy"
			src={url}
		/>
	);
};

export default LogoImage;
